import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { useLocation } from 'react-router-dom';
import { getUrlOpenCase } from 'app/components/helpers';
import { DisplayLink } from 'ui';

interface TooltipCaseNumberProps {
  value: string;
}

export const TooltipCaseNumber: React.FC<TooltipCaseNumberProps> = ({ value }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  
  if(!value) {
    return null;
  }
  return (
    <DisplayLink url={toAbsoluteUrl(getUrlOpenCase(Number(value), currentPath, searchParams))}/>
  );
};
